import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Button, Grid, Header, Segment } from 'semantic-ui-react';
import { useStore } from '../../../../app/stores/store';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import MyTextInput from '../../../../app/common/form/MyTextInput';
import sendRespectiveEmail from '../../../../app/models/EmailNew';
import agent from '../../../../app/api/agent';
import { toast } from 'react-toastify';

function DashboardBillingForm() {
  const {
    activityStore: {
      outwardFetchTableDetails,
      selectedActivity,
      outward: { billing },
    },
    commonStore,
    userStore,
    dashboardStore,
  } = useStore();

  const [deliveryRequestId, setDeliveryRequestId] = useState<string>('');

  const [initialValue, setInitialValue] = useState<{
    billType: string;
    billingAmount: string;
    billingCode: string;
  }>({
    billType: '',
    billingAmount: '',
    billingCode: '',
  });

  useEffect(() => {
    if (deliveryRequestId !== '') {
      const tempValue = {
        billType: '',
        billingAmount: '',
        billingCode: '',
      };
      if (billing.billType !== '') {
        tempValue.billType = billing.billType;
      }
      if (billing.amount !== '') {
        tempValue.billingAmount = billing.amount;
      }
      setInitialValue(tempValue);
    }
  }, [billing, deliveryRequestId]);

  useEffect(() => {
    let id = '';
    billing?.data?.forEach((localData: any) => {
      if (localData.id === selectedActivity?.id) {
        id = localData?.deliveryRequestId;
      }
    });
    setDeliveryRequestId(id);
    // eslint-disable-next-line
  }, [billing?.data, selectedActivity?.id]);

  const handleFormSubmit = async (values: {
    billType: string;
    billingAmount: string;
    billingCode: string;
  }) => {
    try {
      const payload = {
        id: deliveryRequestId,
        type: values.billType,
        cost: values.billingAmount,
        code: values.billingCode,
      };
      let result = await agent.Outwards.outwardBillingUpdate(payload);
      if (result?.data?.includes('successfully')) {
        commonStore.updateHistoryAlonePOST(
          `The Billing for asset ${selectedActivity?.title} is successfully completed by ${userStore.user?.displayName}`,
          selectedActivity?.id,
          undefined,
          true,
          true,
        );
        await agent.InventoryDelivery.OrderTrackingStatus(
          selectedActivity?.id,
          'Outward Asset Billed',
        );
      } else {
        commonStore.updateHistoryAlonePOST(
          result?.data,
          selectedActivity?.id,
          undefined,
          true,
          true,
        );
      }
      sendRespectiveEmail(
        'edited',
        selectedActivity?.title || '',
        'Delivery Billing',
        '',
      );
      dashboardStore.dashboard.OutwardTableBillingClicked = '';
      outwardFetchTableDetails(
        '',
        dashboardStore.dashboard.billingPagination,
        'Billing',
      );
      handlecancel();
    } catch {
      toast.error('Something went wrong');
    }
  };

  const handlecancel = () => {
    setDeliveryRequestId('');
    setInitialValue({
      billType: '',
      billingAmount: '',
      billingCode: '',
    });
  };

  return (
    <>
      <Segment
        clearing
        style={{
          marginTop: '10px',
          height: '61.7vh',
        }}
        responsive={true}
      >
        <Header
          icon="edit"
          size="huge"
          dividing
          as="h1"
          content="Billing"
          sub
          color="grey"
        />
        <Formik
          initialValues={initialValue}
          enableReinitialize={true}
          onSubmit={(values) => {
            handleFormSubmit(values);
          }}
          validationSchema={Yup.object({
            billType: Yup.string().required('Please Specify Type'),
            billingAmount: Yup.string().required('Please Specify Amount'),
            billingCode: Yup.string().required('Please Specify Code'),
          })}
        >
          {({ handleSubmit, isValid, dirty }) => (
            <Form
              style={{ marginTop: '15px', height: '55.7vh' }}
              className="ui form error"
              autoComplete="off"
              onSubmit={handleSubmit}
            >
              <Grid container columns={1}>
                <Grid.Column fluid>
                  {' '}
                  <MyTextInput
                    name="billType"
                    placeholder="Bill Type"
                    label="Bill Type"
                  />{' '}
                </Grid.Column>
                <Grid.Column>
                  {' '}
                  <MyTextInput
                    name="billingAmount"
                    placeholder="Cost"
                    label="Cost"
                  />{' '}
                </Grid.Column>
                <Grid.Column>
                  {' '}
                  <MyTextInput
                    name="billingCode"
                    placeholder="Billing Code"
                    label="Billing Code"
                  />{' '}
                </Grid.Column>
              </Grid>
              <Button.Group
                floated="left"
                style={{
                  position: 'absolute',
                  bottom: '-5px',
                  left: '5px',
                }}
              >
                <Button
                  floating="left"
                  onClick={() => {
                    handlecancel();
                  }}
                >
                  Cancel
                </Button>
                <Button.Or />
                <Button
                  disabled={!isValid || !dirty}
                  type="submit"
                  content="Submit"
                  positive
                >
                  Save
                </Button>
              </Button.Group>
            </Form>
          )}
        </Formik>
      </Segment>
    </>
  );
}

export default observer(DashboardBillingForm);
